/// <reference path="../../typings/globals/jquery/index.d.ts" />
let todaysDeals = null, seeAlsos = null, complementaryProducts = null, otherTodaysDeals = null, bestsellers = null, newProducts = null, resetPasswordForm, vis;

import { ErrorsLogger } from "./classes/page/ErrorsLogger.class";
import { ExtendedIntersectionObserver } from "./classes/page/ExtendedIntersectionObserver.class";
import { BootstrapExtensions } from "./classes/bootstrap/BootstrapExtensions.class";
import { Tools } from "./classes/tools/Tools.class";
import { Page } from "./classes/page/Page.class";
import { Navi } from "./classes/Navi.class";
import { Search } from "./classes/search/Search.class";
import { Cart } from "./classes/cart/Cart.class";
import { AddToCart } from "./classes/cart/AddToCart.class";
import { ListingControler } from "./classes/listing/ListingControler.class";
import { Login } from "./classes/forms/Login.class";
import { Form } from "./classes/forms/Form.class";
import { ModalForm } from "./classes/forms/ModalForm.class";
import { Inputs } from "./classes/forms/Inputs.class";
import { Pvi } from "./classes/pvi/Pvi.class";
import { CreatePVIHtmlFromJSON } from "./classes/pvi/CreatePVIHtmlFromJSON.class";
import { DealersZone } from "./classes/DealersZone.class";
import { VerticalImageSlider } from "./classes/VerticalImageSlider.class";

window.Modules = new Object; // dla porządku by wszystkie klasy były w 1 obiekcie
window.Modules.Form = Form; // wystawia klasę po za moduł
window.Modules.ModalForm = ModalForm; // wystawia klasę po za moduł
window.Modules.Inputs = Inputs; // wystawia klasę po za moduł
window.Modules.BootstrapExtensions = BootstrapExtensions; // wystawia klasę po za moduł
window.Modules.ExtendedIntersectionObserver = ExtendedIntersectionObserver; // wystawia klasę po za moduł

loggerObj = new ErrorsLogger();
toolsObj = new Tools();

pageObj = new Page({
	onDOMLoaded: function(){
		if ( pageObj.settings.bootstrap.kind == 'mobile' ) // dopisane po wylaczeiu stuck
			if ( $(window).scrollTop() < 1 ) {
				$('body').addClass('scrollTop');
			}

		naviObj.init();
		searchObj.init();
		bootstrap.init();
		login.initLoginForm();

		if ( INDEX_TERAZ || TOWARY_PROMO || TOWARY_PIERWSZA_STR || $('#addTodaysDeals').length > 0 || $('#addBestsellers').length > 0 || $('#addNewProducts').length > 0 ) {
			if ( $('#todaysDeals').length > 0 ) todaysDeals = new Pvi('todaysDeals', 'todaysDeal', 2);

			if ( $('#todaysOutlets').length > 0 ) todaysDeals = new Pvi('todaysOutlets', 'todaysOutlet', 2);

			if ( $('#otherTodaysOutlets').length > 0 ) {
				otherTodaysDeals = new Pvi('otherTodaysOutlets', 'otherTodaysOutlet', 2);
				$('#otherTodaysOutlets').addClass("mt-3");
			}

			if ( $('#bestsellers').length > 0 ) bestsellers = new Pvi('bestsellers', 'bestseller', 2);

			if ( $('#addNewProducts').length > 0 ) {
				var emptyNewProducts = new CreatePVIHtmlFromJSON({
					triggerTarget: 'addNewProducts',
					JSONUrl: '/ajaxTowaryNowosc?i='+QUANTITY_OF_NEW_PRODUCTS,
					JSONRoot: 'towaryNowosci',
					showPromoPrice: false,
					pviModuleID: 'newProducts',
					pviModuleBoxClass: 'newProduct',
					onPVIReady: function(){
						newProducts = new Pvi('newProducts', 'newProduct', 2);
						addToCart.init();
					}
				});
			}

			if ( $('#addTodaysDeals').length > 0 ) {
				$('#addTodaysDeals h2').fadeOut(0);
				var emptyTodaysDeals = new CreatePVIHtmlFromJSON({
					triggerTarget: 'addTodaysDeals',
					JSONUrl: '/ajaxTowaryPromo',
					JSONRoot: 'TowaryPromo',
					pviModuleID: 'todaysDeals',
					pviModuleBoxClass: 'todaysDeal',
					onPVIReady: function(){
						$('#addTodaysDeals h2').fadeIn(FADE_IN_QUEUE_DELAY);
						todaysDeals = new Pvi('todaysDeals', 'todaysDeal', 2);
						addToCart.init();
					}
				});
			}

			if ( $('#addBestsellers').length > 0 ) {
				var emptyBestsellers = new CreatePVIHtmlFromJSON({
					triggerTarget: 'addBestsellers',
					JSONUrl: '/ajaxTowaryPierwszaStr',
					showPromoPrice: false,
					JSONRoot: 'towaryPierwszaStr',
					pviModuleID: 'bestsellers',
					pviModuleBoxClass: 'bestseller',
					onPVIReady: function(){
						bestsellers = new Pvi('bestsellers', 'bestseller', 2);
						addToCart.init();
						toolsObj.alignElementsHeight('bestseller');
						toolsObj.initClickAction();
					}
				});
			}
		}

		if ( INDEX_TERAZ ) {
			if ( $('#mainPageBrands').length > 0 ) {
				toolsObj.ajaxLoadData({
					url: '?current_action=ajax&get=brands',
					loadingMode: false,
					updateBrowserHistory: false,
					forceAjaxPageLoad: true,
					target: '#mainPageBrands',
					sourceOfError: 'APP::get=brands'
				});
			}
		}

		if ( TOWAR ) {
			bootstrap.initPopovers({
				selector: '#product .addPopover',
				placement: 'top'
			});

			//if ( PRZYPISANIA ) {
				if ( $('#seeAlsos').length > 0 )
					todaysDeals = new Pvi('seeAlsos', 'seeAlso', 3);
			//}

			if ( $('#complementaryProducts').length > 0 )
				bestsellers = new Pvi('complementaryProducts', 'complementaryProduct', 3);

			toolsObj.initScrollTo('.scrollToProductData', true);

			listing.initCompare();
			listing.initFavorites();

			pageObj.reorganizeProductPage();
		}

		if ( INDEX_TERAZ || TOWAR || TOWARY || TOWARY_PROMO || TOWARY_PIERWSZA_STR ) {
			if ( $('#countDownShipmentTime').length > 0 ) {
				toolsObj.addShipmentCounter('#countDownShipmentTime', '#shipmentTime');
			}

			if ( $('.promoTimer').length > 0 ) {
				toolsObj.addPromoCounter();
			}

			addToCart.init();
		}

		if ( CART ) {
			bootstrap.initPopovers({
				selector: '#cart .addPopover',
				placement: 'top'
			});
			cart.init();
		}

		if ( TOWARY || BESTSELLERS_PAGE ) {
			listing.initListingControlers();
		}

		if ( RESETOWANIE_HASLA ) {
			resetPasswordForm = new Form({
				selector: 'form#passwordResetForm'
			});
		}

		if ( COMPARE ) {
			addToCart.init();
			listing.initCompare();
		}

		if ( STREFA_DYSTRYBUTORA ) {
			dZoneObj = new DealersZone();
		}

		if ( $('.hashLink').length > 0 )
			pageObj.initScrollToHash();

		if ( $('.changeCurrencyBtn').length > 0 ) {
			$('.changeCurrencyBtn').on('click', function(){
				toolsObj.changeCurrency($(this).data('currency'));
			});
		}

		if ( $('.varPanel').length > 0 ) {
			if ( $('#errorInfo').length > 0 )
				$('.varPanel').insertAfter('#errorInfo');
			else
				$('.varPanel').prependTo('section');
		}

		toolsObj.initClickAction();
		toolsObj.initScrollTo('.scrollToHash');

		if ( $('.checkInstalments').length > 0 ) {
			$('.checkInstalments').each(function(i,e){
				$(e).on('click', function(event){
					let value = $(e).data('raty-cena');
					policzRateKoszyka(value);
					event.stopPropagation();
				});
			});
		}

		if ( $('.vis').length > 0 ) {
			vis = new VerticalImageSlider({});
		}
	},
	onPageLoaded: function(){
		//cart.refreshCartCounter();

		if ( window.location.hash ) {
			if ( window.location.hash.includes("#login") ) {
				setTimeout(function(){
					$('#myAccountBtn').trigger('click').trigger('mouseout');
				}, 1000);
			}
			setTimeout(function(){
				pageObj.fixAutoScrollToHash();
			}, 1000);
		}

		toolsObj.refreshAjaxHistory();

		pageObj.updateInfoAfterPageLoaded();

		setTimeout(function(){
			$('body').addClass('loaded');
		}, 1500);

		if ( toolsObj.getParameterValueFromURLbyName('scrollTo') ) {
			toolsObj.scrollTo('#' + toolsObj.getParameterValueFromURLbyName('scrollTo'));
		}
	},
	onResize: function(){
		searchObj.autocompleteUpdateBtnLeftPosition();
		searchObj.autocompleteHide();

		if ( NAV2023 ) {
			if ( $("#navbarMobile2023 #navMobile").hasClass("show") ) {
				var new_menu2023_currWidth;

				clearTimeout(naviObj.menu2023_resizeControlTimer);
				new_menu2023_currWidth = $(window).width();
				naviObj.menu2023_resizeControlTimer = setTimeout(function () {
					if ( naviObj.menu2023_currWidth != new_menu2023_currWidth ) {
						$("#navbarMobile2023 #navMobile #navBtnToggle").trigger("click");
						naviObj.menu2023_currWidth = $(window).width(); // nie new_menu2023_currWidth
					}
				}, 100);
			}
		}

		if ( STREFA_DYSTRYBUTORA ) {
			dZoneObj.adjustNavi();
		}
	},
	onResizeTriggered: function(){
		if ( pageObj.settings.bootstrap.kind == 'mobile' )  // dopisane po wylaczeiu stuck
			if ( $(window).scrollTop() < 1 ) {
				$('body').addClass('scrollTop');
			} else {
				$('body').removeClass('scrollTop');

			}

		toolsObj.setImg();

		if ( INDEX_TERAZ || TOWAR || TOWARY || TOWARY_PROMO || TOWARY_PIERWSZA_STR )
			listing.updateListingElementsHeight();

		if ( TOWARY )
			listing.updateListingElementsOrder();

		if ( todaysDeals !== null )
			todaysDeals.adjustAllNameContHeight();

		if ( newProducts !== null )
			newProducts.adjustAllNameContHeight();

		if ( bestsellers !== null )
			bestsellers.adjustAllNameContHeight();

		if ( seeAlsos !== null )
			seeAlsos.adjustAllNameContHeight();

		if ( complementaryProducts !== null )
			complementaryProducts.adjustAllNameContHeight();

		if ( TOWAR )
			pageObj.reorganizeProductPage();
	},
	onScroll: function(){
		searchObj.autocompleteHide();
		searchObj.hideMobileSearchPanel();

		if ( pageObj.settings.bootstrap.kind == 'mobile' ) { // dopisane po wylaczeiu stuck
			if ( $(window).scrollTop() < 1 ) {
				$('body').addClass('scrollTop');
			} else {
				$('body').removeClass('scrollTop');
			}
		}
	},
	onMatchMediaChange: function(){
		naviObj.update();

		if ( todaysDeals !== null )
			todaysDeals.update();

		if ( newProducts !== null )
			newProducts.update();

		if ( bestsellers !== null )
			bestsellers.update();

		if ( seeAlsos !== null )
			seeAlsos.update();

		if ( complementaryProducts !== null )
			complementaryProducts.update();

		if ( TOWARY ) {
			searchObj.adjustFoundCategoriesToViewKind();
			listing.adjustFilteringToViewKind();
		}
	},
	onPopstate: function(){
		if ( TOWARY ) {
			listing.loadProductsListing({forceAjaxPageLoad: true, eventPopstate: this});
		}
		if ( PANEL ) {
			var urlPopState = window.location.href;
			( urlPopState.includes("?") )? urlPopState = urlPopState + "&" : urlPopState = urlPopState + "?";
			urlPopState = urlPopState + "current_action=ajax";
			ajaxLoad(urlPopState, true);
		}
	}
});

searchObj = new Search({
	mainContID: 'naviSearchBar',
	searchInputID: 'search'
});

let addToCart = new AddToCart();
let cart = new Cart(); // koszyk i schowek
let login = new Login();
let bootstrap = new BootstrapExtensions();
let listing = new ListingControler(bootstrap);

naviObj = new Navi({
	onMobileMenuBtnClick: function(){
		searchObj.canHideMobileSearchPanel = true;
		searchObj.hideMobileSearchPanel();
		//pageObj.scrollPageToNaviStuckState();
	},
	onChangeNaviToMobileView: function(){
		searchObj.hideMobileSearchPanel();
	},
	onChangeNaviToDesktopView: function(){
		bootstrap.initPopovers({
			selector: '#mainNavi .addPopover'
		});
		bootstrap.initPopovers({
			selector: '#navbarDesktop .addPopover',
			fixPosition: true
		});
	}
});